import src from "IMAGE";
export default { src, width: 179, height: 157, blurWidth: 0, blurHeight: 0};
